import React from 'react';
import { OV_STRINGS } from '../../constants/strings';
import styles from './MembershipRequiredModal.module.scss';

const IMG_PATH = `${process.env.REACT_APP_IMAGE_BASE_URL || "/images"}/icon/img-ov-membership-required.png`;

function MembershipRequiredModal({ onConfirm, onClose }) {
  return (
    <>
      <div className={styles.dim} onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }} />
      <div className={styles.pos}>
        <div className={styles.modal}>

          <div className={styles.nav}>
            <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="#171719" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          <div className={styles.contents}>
            <div className={styles.thumbnail}>
              <img src={IMG_PATH} alt="" />
            </div>
            <div className={styles.heading}>
              <h2 className={styles.title}>{OV_STRINGS.MEMBERSHIP_REQUIRED_TITLE}</h2>
              <p className={styles.desc}>{OV_STRINGS.MEMBERSHIP_REQUIRED_DESC}</p>
            </div>
          </div>

          <div className={styles.actionArea}>
            <button type="button" className={styles.cta} onClick={onConfirm}>
              {OV_STRINGS.MEMBERSHIP_REQUIRED_BUTTON}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default MembershipRequiredModal;
